import React from 'react';
import PropTypes from 'prop-types';
import { cx } from './classNames';

/**
 * A placeholder bar as the Performance tab's loading tables draw theirs
 * (MUI's rounded wave Skeleton in the app theme, MuiSkeleton in
 * styles/msiMuiComponentOverrides.js): 11px tall with round ends and no
 * outline, a faint tint of the text colour (the colour of DotWaveLoader's
 * dots) and a stronger band of it sweeping across (a still bar under reduced
 * motion). The mask keeps the band clipped to the round ends in Safari, as
 * MUI's does. `width` is any CSS width (a number is px).
 * Hidden from assistive technology; mark the busy region with aria-busy.
 */
export default function Skeleton({ width, className }) {
    return (
        <span
            aria-hidden="true"
            data-skeleton=""
            className={cx(
                'relative block h-[11px] max-w-full overflow-hidden rounded-[7px] bg-content-primary/[0.04]',
                '[-webkit-mask-image:-webkit-radial-gradient(white,black)]',
                "after:absolute after:inset-0 after:-translate-x-full after:content-['']",
                'after:bg-gradient-to-r after:from-transparent after:via-content-primary/[0.12] after:to-transparent',
                'after:animate-skeleton-wave motion-reduce:after:animate-none',
                className,
            )}
            style={width == null ? undefined : { width }}
        />
    );
}

Skeleton.propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    className: PropTypes.string,
};
